import PrescriberAdmin from "./PrescriberAdmin";
export default PrescriberAdmin;
